import { groupArrayByKeys } from '@campus/utils';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RecommendationInterface, RecommendationScenarioType } from '../../+models';
import { NAME, State, selectAll, selectEntities } from './recommendation.reducer';

export const selectRecommendationState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectRecommendationState, (state: State) => state.error);

export const getAll = createSelector(selectRecommendationState, selectAll);

export const getAllEntities = createSelector(selectRecommendationState, selectEntities);
export const getAllEntitiesByModuleId = createSelector(getAll, (recommendations) => {
  const addModuleId = (r: RecommendationInterface) => {
    const tocId = r.moduleId ? new URL(r.moduleId).searchParams.get('toc') : null;

    return { ...r, moduleId: tocId };
  };

  return groupArrayByKeys(recommendations, ['moduleId'], null, false, addModuleId);
});

export const getById = (props: { id: string }) => createSelector(getAllEntities, (state) => state[props.id]);

export const getRecommendationsForCourse = (courseGuid: string) =>
  createSelector(getAll, (recommendations) => recommendations.filter((rec) => rec.courseGuid === courseGuid));

export const isTocLoaded = (props: { tocId: number }) =>
  createSelector(selectRecommendationState, (state: State) => !!state.byTocId[props.tocId]);

export const selectByScenario = createSelector(selectRecommendationState, (state: State) => state.byScenario);
export const selectRecommendationsByScenario = createSelector(
  selectByScenario,
  getAllEntities,
  (byScenario: State['byScenario'], recommendationsByConcept: State['entities']) => {
    const recommendationsByScenario = Object.entries(byScenario).reduce(
      (acc, [scenario, conceptGuids]) => {
        const recommendations = (conceptGuids || []).map((conceptGuid) => recommendationsByConcept[conceptGuid]);
        return {
          ...acc,
          [scenario]: recommendations,
        };
      },
      {} as Record<RecommendationScenarioType, RecommendationInterface[]>
    );

    return recommendationsByScenario;
  }
);
export const selectByTocId = createSelector(selectRecommendationState, (state: State) => state.byTocId);
export const selectRecommendationsByTocId = createSelector(
  selectByTocId,
  getAllEntities,
  (byTocId: State['byTocId'], recommendationsByConcept: State['entities']) => {
    const recommendationsByToc = Object.entries(byTocId).reduce(
      (acc, [tocId, conceptGuids]) => {
        const recommendations = conceptGuids.map((conceptGuid) => recommendationsByConcept[conceptGuid]);
        return {
          ...acc,
          [tocId]: recommendations,
        };
      },
      {} as Record<string, RecommendationInterface[]>
    );

    return recommendationsByToc;
  }
);

export const isScenarioLoaded = (props: { scenario: RecommendationScenarioType }) =>
  createSelector(
    selectRecommendationState,
    (state: State) => !!(state.byScenario[props.scenario] && Array.isArray(state.byScenario[props.scenario]))
  );
